module.exports = __webpack_public_path__ + "static/media/declined.5465ec48.svg";